import req from "../http";

const language = {
  // 取得 語言
  getLanguage(params) {
    return req("get", "/BasicInformation/ForeignLanguage", params);
  },
  // 取得 程度
  getLanguageDegree(params) {
    return req("get", "/BasicInformation/LanguageDegree", params);
  },
};

export default language;